// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  googleMapsApiKey : "AIzaSyBiwhv-1-KqqULpk7clxJXlYqH9EIrCslc",
  // Asistente de prescripción por voz. Vive fuera de Aliwell Cloud; el código es
  // una llave fija de validación, no un secreto. Aquí y no en el componente para
  // poder cambiarlos sin buscarlos entre el código.
  voiceRx: {
    url: "https://aliwell.mx/prescripcion-ali",
    code: "190816"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
